<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">首页 / 赛事报名 / 赛事详情</div>
      <div class="title">{{ info.name }}报名</div>
      <div class="type_con">
        <div v-for="item in info.entriesList" :key="item.id" :class="{'type_sel': currentTypeId === item.id,}"
             class="type_item" @click="currentTypeId = item.id">
          <div>{{ item.entriesName }}</div>
          <div class="type_num">￥{{ item.price ? item.price.toFixed(2) :0}}</div>
        </div>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules"
               class="demo-ruleForm" label-width="210px">
        <el-form-item class="form_item" label="姓名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入" style="width: 466px"></el-input>
        </el-form-item>
        <el-form-item class="form_item" label="昵称" prop="nickname">
          <el-input v-model="ruleForm.nickname" placeholder="请输入" style="width: 466px"></el-input>
        </el-form-item>
        <el-form-item class="form_item" label="性别" prop="sex">
          <el-select v-model="ruleForm.sex" style="width: 466px">
            <el-option :value="1" label="男"></el-option>
            <el-option :value="2" label="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form_item" label="身份证号" prop="idNumber">
          <el-input v-model="ruleForm.idNumber" placeholder="请输入" style="width: 466px"></el-input>
        </el-form-item>
        <el-form-item class="form_item" label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入" style="width: 466px"></el-input>
        </el-form-item>
        <!--        <div class="line"></div>-->
        <!--        <el-form-item label="所属单位名称" prop="ssdw" class="form_item">-->
        <!--          <el-input v-model="ruleForm.ssdw" placeholder="请输入" style="width: 466px"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="团队名称" class="form_item">-->
        <!--          <el-input v-model="ruleForm.tdmc" placeholder="请输入" style="width: 466px"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="团队负责人" class="form_item">-->
        <!--          <el-input v-model="ruleForm.fzr" placeholder="请输入" style="width: 466px"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="团队负责人手机号" class="form_item">-->
        <!--          <el-input v-model="ruleForm.fzrsjh" placeholder="请输入" style="width: 466px"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="上传团队照片" class="form_item">-->
        <!--          <el-upload-->
        <!--              class="upload-demo"-->
        <!--              action="#"-->
        <!--              multiple>-->
        <!--            <el-button>上传图片</el-button>-->
        <!--          </el-upload>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="参赛组别" class="form_item">-->
        <!--          <el-input v-model="ruleForm.zb" placeholder="请输入" style="width: 466px"></el-input>-->
        <!--        </el-form-item>-->
      </el-form>
      <el-button class="bm_btn" type="primary" @click="immediatelyClick">立即报名</el-button>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
import {post} from '@/utils/request'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'

export default {
  name: "eventRegistration",
  data() {
    // 自定义验证
    const validPhone = (rule, value, callback) => {
      const reg = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!reg.test(value.replace(/\s/g, ""))) { //判断用户输入的值是否符合规则
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    // 自定义验证
    const validId = (rule, value, callback) => {
      const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
      if (!value) {
        callback(new Error('请输入身份证号'))
      } else if (!reg.test(value.replace(/\s/g, ""))) { //判断用户输入的值是否符合规则
        callback(new Error('请输入正确的身份证号'))
      } else {
        callback()
      }
    }
    return {
      currentTypeId: 1,

      ruleForm: {
        name: '',
        nickname: '',
        sex: null,
        idNumber: '',
        phone: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        nickname: [
          {required: true, message: '请输入昵称', trigger: 'blur'}
        ],
        sex: [
          {required: true, type: 'number', message: '请输入性别', trigger: 'change'}
        ],
        idNumber: [
          {required: true, validator: validId, trigger: 'blur'}
        ],
        phone: [
          {required: true, validator: validPhone, trigger: 'blur'}
        ],
      },
      info: {}
    }
  },
  created() {
    this.info = JSON.parse(this.$route.query.item)
    this.currentTypeId = this.info.entriesList[0].id
  },
  methods: {
    immediatelyClick() {
      if (!getToken()) {
        this.$confirm('未登录或登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
        ).then(() => {
          removeToken()
          router.push({ path: '/login' })
        }).catch(() => {
        });
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          post('/gateway/order-table/addOrder', {
            ...this.ruleForm,
            manangementId: this.info.id,
            eventId: this.currentTypeId
          }).then(res => {
            if (res.code === 0) {
              this.$message.success('报名成功')
              this.$router.push('/mineCenter/MineOrderForGoods/eventOrders')
            }
          })
        } else {
          return false;
        }
      });

    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-weight: 700;
  font-size: 48px;
  text-align: center;
}

.type_con {
  flex-wrap: wrap;
  margin: 66px 0 73px;
  display: flex;
  justify-content: center;

  .type_item {
    width: calc((100% - 80px) / 5);
    height: 147px;
    background: #0058a600;
    border: 1px solid #0058A6;
    border-radius: 4px;
    margin-bottom: 20px;
    justify-content: center;
    font-size: 28px;
    color: #0058A6;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 15px;
    margin-right: 10px;
    &:nth-child(5n){
      margin-right: 0;
    }

    &:nth-child(5n) {
      margin-right: 0;
    }

    &:last-child {
      //margin-right: 0;
    }

    .type_num {
      font-weight: 700;
      font-size: 36px;
    }
  }

  .type_sel {
    background: #0058A6;
    color: #ffffff;
  }
}

.form_item {
  width: 700px;
  margin: 20px auto;
}

.line {
  height: 1px;
  background: #DCDCDC;
  margin: 40px 0;
}

.bm_btn {
  width: 308px;
  display: block;
  margin: 104px auto 66px;
}
</style>
